import React, { useState, useEffect } from 'react';
import './AdminArchivos.css';

const AdminArchivos = ({ onVolver }) => {
  const [archivos, setArchivos] = useState([]);
  const [displayName, setDisplayName] = useState('');
  const [file, setFile] = useState(null);
  const [isProtected, setIsProtected] = useState(false);
  const [aniPassword, setAniPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchAdminArchivos = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('https://api.interventorsisgafr.com/api/archivos/admin', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!response.ok) {
            throw new Error('No se pudo obtener la lista de archivos.');
        }
        const data = await response.json();
        setArchivos(data);
      } catch (err) {
          setError(err.message);
      }
    };
    fetchAdminArchivos();
  }, []);

  const handleFileSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!displayName || !file) {
      return setError('Se requiere un nombre y un archivo.');
    }
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('displayName', displayName);
    formData.append('archivo', file);
    formData.append('isProtected', isProtected);
    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/archivos', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });
      const newArchivo = await response.json();
      if (!response.ok) throw new Error(newArchivo.msg || 'Error al subir el archivo');
      
      setArchivos([newArchivo, ...archivos]);
      
      setSuccess('¡Archivo subido con éxito!');
      setDisplayName('');
      setFile(null);
      setIsProtected(false);
      document.querySelector('input[type="file"]').value = '';
    } catch (err) {
      setError(err.message);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    const token = localStorage.getItem('token');
    try {
      const response = await fetch('https://api.interventorsisgafr.com/api/settings/ani-password', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ password: aniPassword })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.msg);
      setSuccess(data.msg);
      setAniPassword('');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar este archivo?')) return;
    const token = localStorage.getItem('token');
    try {
      const response = await fetch(`https://api.interventorsisgafr.com/api/archivos/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if(!response.ok) throw new Error('Error al eliminar el archivo');
      setArchivos(archivos.filter(a => a.id !== id));
      setSuccess('Archivo eliminado con éxito.');
    } catch (err) {
      setError(err.message);
    }
  };
  
  const archivosPublicos = archivos.filter(a => !a.is_protected);
  const archivosProtegidos = archivos.filter(a => a.is_protected);

  return (
    <div className="admin-archivos-container">
      <button onClick={onVolver} className="volver-btn">&lt; Volver</button>
      <h2>Gestión de Archivos</h2>
      {error && <p className="error-message">{error}</p>}
      {success && <p className="success-message">{success}</p>}
      <div className="admin-archivos-content">
        <form onSubmit={handleFileSubmit} className="archivo-form">
          <h3>Subir Nuevo Archivo</h3>
          <input type="text" placeholder="Nombre visible del archivo" value={displayName} onChange={e => setDisplayName(e.target.value)} required />
          <input type="file" accept=".pdf,.xls,.xlsx" onChange={e => setFile(e.target.files[0])} required />
          <div className="form-group-checkbox">
            <input type="checkbox" id="isProtected" checked={isProtected} onChange={(e) => setIsProtected(e.target.checked)} />
            <label htmlFor="isProtected">Documento para la ANI (protegido)</label>
          </div>
          <button type="submit">Guardar Archivo</button>
        </form>

        <form onSubmit={handlePasswordSubmit} className="password-form">
          <h3>Contraseña de la ANI</h3>
          <p>Establece o actualiza la contraseña para los documentos protegidos.</p>
          <div className="password-input-group">
            <input type="password" value={aniPassword} onChange={(e) => setAniPassword(e.target.value)} placeholder="Nueva contraseña (mín. 6 caracteres)" required />
            <button type="submit">Establecer / Actualizar</button>
          </div>
        </form>
      </div>

      <div className="archivos-list-wrapper">
        <div className="archivos-list">
          <h3>Archivos Públicos Actuales</h3>
          {archivosPublicos.map(archivo => (
            <div key={archivo.id} className="archivo-item">
              <span>{archivo.display_name}</span>
              <button onClick={() => handleDelete(archivo.id)} className="delete-btn">Eliminar</button>
            </div>
          ))}
        </div>

        <div className="archivos-list">
          <h3>Archivos ANI Actuales</h3>
          {archivosProtegidos.map(archivo => (
            <div key={archivo.id} className="archivo-item protected">
              <span>🔒 {archivo.display_name}</span>
              <button onClick={() => handleDelete(archivo.id)} className="delete-btn">Eliminar</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminArchivos;